<div class="spinner-wrapper" *ngIf="loading">
  <mat-spinner [diameter]="50"
               [color]="'accent'"
  ></mat-spinner>
</div>

<jf-pdf-viewer
  [src]="blob"
  [isLoaded]="!loading"
  [useIFrame]="false"
  [highlightText]="highlightText"
  [showErechnungIcon]="isERechnung"
  (download)="doDownloadBeleg()"
></jf-pdf-viewer>
